import { useIntl } from 'react-intl'
import Sheet from 'components/utils/Sheet'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import TextButton from 'LuxKit/Button/TextButton'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import { NO_24_7_SUPPORT_REGIONS } from 'constants/config/region'

interface Props {
  currentRegionCode: string
  phoneNumber: string
  phoneLabel: string
  callbacksFeatureEnabled: boolean
  onCallbackButtonClick: () => void
}

function MultiRoomBookingAssistance({ currentRegionCode, phoneNumber, phoneLabel, callbacksFeatureEnabled, onCallbackButtonClick }: Props) {
  const intl = useIntl()
  const limitedHoursLabel = intl.formatMessage({
    id: 'WwAw1OMtcLdeKlcUqvGX',
    defaultMessage: 'Our team are available 7 days a week from 9am to 7pm',
    description: 'Support availability message for regions without 24/7 support',
  })
  const fullHoursLabel = intl.formatMessage({
    id: '8JPALsyZTPzYnQudUPT6',
    defaultMessage: 'Our team are available 24 hours, 7 days',
    description: 'Support availability message for regions with 24/7 support',
  })

  return (
    <Sheet background="light-background" padding={20}>
      <Group direction="vertical" gap={8}>
        <Group direction="vertical" gap={4}>
          <BodyText variant="medium" weight="bold">
            {intl.formatMessage({
              id: 'N9bY8xN-vdb3upPfjBcL',
              defaultMessage: 'Ready to book? Call us to complete your booking',
              description: 'Heading prompting user to call to complete multi-room booking',
            })}
          </BodyText>
          <BodyText variant="medium">
            {NO_24_7_SUPPORT_REGIONS.includes(currentRegionCode) ? limitedHoursLabel : fullHoursLabel}
          </BodyText>
        </Group>
        <TextButton startIcon={<LinePhoneIcon />} kind="primary" href={`tel:${phoneNumber}`} fit="flex">
          {intl.formatMessage(
            {
              id: 'Y86IWbONeZPFFfPd9r7n',
              defaultMessage: 'Call {phoneNumber}',
              description: 'Action button label to call support with phone number',
            },
            { phoneNumber: phoneLabel },
          )}
        </TextButton>
        {callbacksFeatureEnabled && (
          <TextButton kind="secondary" fit="flex" onClick={onCallbackButtonClick}>
            {intl.formatMessage({
              id: 'B4gcrc2d3BbYkCRfnHQV',
              defaultMessage: 'Request a callback',
              description: 'Button text to request agent callback for multi-room booking',
            })}
          </TextButton>
        )}
      </Group>
    </Sheet>
  )
}

export default MultiRoomBookingAssistance
